import type { IControlSettingData, IControlSettingUI, PayloadControlChange } from '../types';
import type { EControlSettingType } from '../../type';

import { useControlSettingStore } from '../../ReportFilter/stores';

interface IUseResetControlData {
  type: EControlSettingType;
  defaultData: IControlSettingData;
  controlChange: (data: PayloadControlChange) => void;
}
export const useResetControlData = ({ type, defaultData, controlChange }: IUseResetControlData) => {
  const controlSettingUI = useControlSettingStore((state) => state.controlSettingUI);

  const getDefaultDataById = (id: string) => defaultData[id]?.value ?? undefined;

  const flattenControls = (controls: IControlSettingUI[] = []): IControlSettingUI[] =>
    controls.flatMap((control) => [control, ...flattenControls(control.controls)]);

  const handleResetControlData = (controlIds: string[]) => {
    const controlUI = controlSettingUI[type];
    const controlIdsSet = new Set(controlIds);

    const controlsToReset = flattenControls(controlUI).filter((ctrl) => controlIdsSet.has(ctrl.id));

    if (!controlsToReset.length) return;

    const resetPayload: PayloadControlChange = {};

    controlsToReset.forEach((ctrl) => {
      ctrl.configs?.forEach((config) => {
        resetPayload[config.id] = getDefaultDataById(config.id);
        config.tabs?.forEach((tab) => {
          resetPayload[tab.id] = getDefaultDataById(tab.id);
        });
      });
    });

    if (!Object.keys(resetPayload).length) return;
    controlChange(resetPayload);
  };

  return {
    handleResetControlData,
  };
};
